import firebaseConfig from '../../../../Utilities/Firebase'
import { getDatabase, ref, set, child, get } from 'firebase/database'
import { initializeApp } from 'firebase/app'
import 'jspdf-autotable'
import generatePdf from './GenerateLc'

const ValidateAndGenerate = (
  retrievedSap,
  lName,
  fName,
  father,
  mother,
  religion,
  subcaste,
  nationality,
  POB,
  DOB,
  prevCollege,
  progress,
  conduct,
  dateAdmission,
  degree,
  course,
  dateLeaving,
  setLcAlreadyGenerated,
  setUploadLoader,
  setServerError,
  LCNumber,
  cgpa
) => {
  setUploadLoader(true)

  const FirebaseApp = initializeApp(firebaseConfig)
  const db = ref(getDatabase(FirebaseApp))
  const d = new Date()
  const date = d.toDateString() + ' ' + d.toLocaleTimeString()
  const data = {
    lc_number: LCNumber,
    sap_id: retrievedSap,
    last_name: lName,
    first_name: fName,
    father_name: father,
    mother_name: mother,
    religion: religion,
    sub_caste: subcaste,
    nationality: nationality,
    place_of_birth: POB,
    date_of_birth: DOB,
    prev_college: prevCollege,
    progress: progress,
    conduct: conduct,
    date_of_admission: dateAdmission,
    degree: degree,
    course: course,
    time_stamp: date,
    date_of_leaving: dateLeaving,
    reason_for_leaving: cgpa,
  }
  //   console.log('⚡️ ~ file: ValidateAndGenerate.js:57 ~ data:', data)
  get(child(db, `generated_lc/${retrievedSap}`))
    .then(snapshot => {
      if (snapshot.exists()) {
        setLcAlreadyGenerated(true)
        console.log('Exists')
      } else {
        console.log('Does not exists')
        upload(data)
      }
    })
    .catch(error => {
      console.log(error)
      setServerError(true)
    })
  upload(data)
  setUploadLoader(false)
}

const upload = data => {
  let up = data
  const FirebaseApp = initializeApp(firebaseConfig)
  const db = getDatabase(FirebaseApp)
  set(ref(db, 'generated_lc/' + data.sap_id), data)
  set(ref(db, 'number_of_lc/'), parseInt(data.lc_number) + 1)
  console.log('Uploaded')
  generatePdf(up)
}

export default ValidateAndGenerate
